module.exports = __webpack_public_path__ + "media/react/marketing/pages/home/toefl/sections/ai/assets/sparkle_bg-f22e9b45a1c7642d5e3f7c0c87129485.svg";